<div class="login-container" fxLayout="column">
  <div style="float: right; margin-right: 10px; margin-top: 10px">
    <button mat-icon-button color="primary" class="m-r-2" style="float: right; margin-top: 10px; margin-right: 10px"
      [ngClass]="showHelpIcon ? 'help-icon-click' : ' help-icon'" (click)="ShowHelp()" id="myLauncher">
      <img [hidden]="hasClass()" src="assets/img/Help.png" style="height: 24px" alt="Help" />
      <img [hidden]="!hasClass()" src="assets/img/Help_Click.png" style="height: 24px" alt="Help" />
    </button>
  </div>

<div fxLayout="column" fxLayoutAlign="center center" style="flex: 1 1 1e-9px ;">
  <mat-card class="mat-card-sty" data-loader="loginbtn">
    <div class="login-box">
        <div class="login-header">
          <div class="logoDiv">
            <img src="assets/img/logo/Transcriber_Logo.png" alt="acord_logo">
            <!-- <div style="width: 37%;display: inline-block;">
              <img src="assets/img/logo/acord-logo.svg" alt="acord_logo" style="width: 100%; margin-bottom: 6px">
            </div>
            <img src="assets/img/Line 1.svg" alt="acord_logo" class="line-class"> -->
            <!-- <img src="assets/img/Transcriber 1.png" style="width: 40%;"> -->
            <!-- <img src="assets/img/logo/transcriber-logo.svg" alt="acord_logo"  style="width: 37%;"> -->
          </div>
          <div class="sh-login-sub-head">Welcome to Transcriber</div>
          <h3 style="margin-bottom: 10px;text-align: center;font-size: 18px;margin-top: 28px;font-family: roboto;">Forgot Password</h3>
          <label
            style="font-size: 18px;text-align: center !important;font-family: roboto;align-items: center;display: block;margin-top: 5px;margin-bottom: 10px;">Don’t
            worry, happens to the best of us!</label>
        </div>
      <form (ngSubmit)="onFormSubmit(forgotPasswordForm.value)" [formGroup]="forgotPasswordForm" *ngIf="!showSuccessMessage">
        <div class="login-content" fxLayout="column">
            <div *ngIf="!showSuccess" style="margin-bottom: 10px">
               
            </div>
            <div style="display: flex">
              <img src="assets/img/logo/Profile.png" class="sh-profile" />
              <label class="sh-label">Username</label>
            </div>
            <mat-form-field floatLabel="never" appearance="outline">
              <input class="inp-sty ng-pristine ng-invalid ng-invalid-required ng-touched" matInput formControlName="email" 
               placeholder="Enter username" style="font-family: Roboto !important;font-style: normal !important;font-weight: 400 !important;color: #4f4f4f;font-size: 14px !important;margin-bottom: -7px;margin-left: -10px;line-height: 22px;" required>
              <mat-error class="err-sty" *ngIf="!forgotPasswordForm.get('email').valid && forgotPasswordForm.get('email').touched">
                {{getEmailErrorMsg()}}
              </mat-error>
            </mat-form-field>
          <div class="login-btn" fxLayout="row" fxLayoutAlign="center center">
            <button mat-raised-button class="mat-primary" type="submit"
              [disabled]="!forgotPasswordForm.valid">Reset Password</button>
          </div>
          <div style="margin-top: 30px">
            <a [routerLink]="['/login']" tabindex="2" class="links">Back to Login</a>
          </div>
        </div>
      </form>
      <div *ngIf="showSuccessMessage" style="margin-top: 25px;">
          <div style="display:flex; margin: 0px 0px 27px 40px; background: #DBF6DB; padding: 7px 14px; align-items: center; border: 1px solid #0CC00C; border-radius: 4px;width: fit-content;">
              <img src="assets/img/success-icon.png" class="recover-pass-class" style="width: 20px;">
              <div style="margin-left: 10px">
                <label><span style="font-weight: 700;">Success</span> Link has been sent to registered Email address</label>
              </div>
          </div>
          <div>
            <a [routerLink]="['/login']" style="color: #0D4B7E;
              text-decoration: underline;
              font-size: 12px;
              text-align: center;
              align-items: center;
              display: block;
              margin-bottom: 40px;">Back to Login</a>
          </div>
      </div>
    </div>
  </mat-card>
</div>
</div>
